import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetMailingUsers = {
  getMailingUsers: { data: null, loading: false, error: null },
};

export const getMailingUsers = createAsyncThunk('user/getMailingUsers', async ({ mailingId, ...data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/chat/mailing/${mailingId}/recipients`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetMailingUsers = {
  [getMailingUsers.pending]: (state) => {
    // state.getMailingUsers.data = null;
    state.getMailingUsers.loading = true;
    state.getMailingUsers.error = null;
  },
  [getMailingUsers.fulfilled]: (state, action) => {
    state.getMailingUsers.loading = false;
    state.getMailingUsers.data = action.payload;
    state.getMailingUsers.error = null;
  },
  [getMailingUsers.rejected]: (state, action) => {
    state.getMailingUsers.loading = false;
    state.getMailingUsers.error = action.payload;
  },
};
